export enum KitElement {
  SHIRT = 'shirt',
  SHORTS = 'shorts',
  SOCKS = 'socks',
  CAP = 'cap',
  HELMET = 'helmet',
}
